import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const SEGNALI = [
  {
    t: "Ti è già capitato un doppio-booking",
    d: "Due clienti che si presentano per lo stesso veicolo nello stesso giorno perché una prenotazione è arrivata per telefono e un'altra su WhatsApp, e nessuno le ha incrociate su un calendario unico. Con un calendario condiviso in tempo reale semplicemente non può succedere.",
  },
  {
    t: "Scrivi ogni contratto a mano, o lo riadatti da un vecchio file Word",
    d: "Ogni consegna richiede riscrivere dati cliente, veicolo e periodo, con il rischio di dimenticare una clausola o sbagliare una data. Un contratto generato automaticamente dai dati della prenotazione elimina sia il tempo sia l'errore di trascrizione.",
  },
  {
    t: "Non sai davvero quale veicolo ti rende di più",
    d: "Senza uno storico strutturato di prenotazioni e incassi è difficile capire quale auto o moto conviene tenere, quale vendere, in che periodi mancano prenotazioni. Sono decisioni che oggi probabilmente prendi a intuito.",
  },
  {
    t: "Ricevi prenotazioni solo quando sei raggiungibile",
    d: "Se il cliente può prenotare solo chiamando o scrivendoti, perdi tutte le richieste fuori orario, nel weekend, o mentre sei impegnato con un altro cliente. Un sito che accetta prenotazioni 24 ore su 24 non chiude mai.",
  },
  {
    t: "Incassi cauzioni e pagamenti solo in contanti o a mano",
    d: "Oltre al rischio di gestione del contante, senza un pagamento pre-autorizzato online le disdette dell'ultimo minuto ti lasciano un veicolo fermo senza copertura.",
  },
  {
    t: "Stai crescendo e Excel non tiene più il passo",
    d: "Un foglio di calcolo che andava bene con 5 veicoli diventa ingestibile con 20-30, più operatori che devono coordinarsi, e nessuno strumento che aggiorni tutti in tempo reale sullo stesso stato delle prenotazioni.",
  },
];

const BC_ITEMS = [{ name: "Quando serve un gestionale", path: "/quando-serve-un-gestionale-per-autonoleggio" }];

export default function QuandoServeGestionale({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["quando-serve-un-gestionale-per-autonoleggio"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Guida</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Quando serve un <mark>gestionale</mark> per il tuo autonoleggio
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            Se ti ritrovi in due o più di questi punti, probabilmente stai
            perdendo tempo — e prenotazioni — che uno strumento dedicato
            recupererebbe da subito.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: "2rem" }}>
            Excel e WhatsApp funzionano bene finché il volume è basso. I
            segnali che è il momento di cambiare di solito non sono uno solo,
            ma un insieme che si accumula nel tempo.
          </p>

          {SEGNALI.map((s) => (
            <div key={s.t} className="an" style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>{s.t}</h2>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{s.d}</p>
            </div>
          ))}

          <div className="an" style={{ marginTop: "2.5rem", padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Come si passa da Excel a un gestionale, in pratica
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              Non serve fermare le prenotazioni per fare il cambio: carichi la
              flotta, colleghi Stripe e condividi il nuovo link di
              prenotazione quando sei pronto, tenendo WhatsApp e telefono
              attivi in parallelo finché non ti senti sicuro. Con
              NoleggioinCloud il sito è già pronto — non lo costruisci da
              zero, lo configuri.
            </p>
            <Link to="/come-funziona" style={{ fontWeight: 600 }}>
              Vedi come funziona il passaggio →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "quando-serve-un-gestionale-per-autonoleggio").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
